// extracted by mini-css-extract-plugin
export default {"label":"CaseViewSelect_label__LWkuE","icon":"CaseViewSelect_icon__cFWlV","selected":"CaseViewSelect_selected__gOy-I","icons":"CaseViewSelect_icons__vmL-8"};